// @flow
import * as React from 'react'

import './H6.scss'

type Props = {
  children: React.Node,
}

export default class H6 extends React.Component<Props> {
  render = () => {
    return <div className="H6">{this.props.children}</div>
  }
}
